import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AdvanceSalesServices } from './advance-sales.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ConstantFees from "../../../shared/constantFees";
import { advancedSalesSellerService } from './advancedSalesSeller.service'
import { AdvancedSalesModel } from './advanced-sales-model';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../shared/services/language.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-advance-sales',
  templateUrl: './advance-sales.component.html',
  styleUrls: ['./advance-sales.component.scss']
})
export class AdvanceSalesComponent implements OnInit {
  id!: number;
  sliderForm!: FormGroup;
  response: any;
  business: any;
  ramMaxValue: number = 0;
  selectedRam: number = 0;
  selectedFees: number = 0;
  sellerRunningAdvancedSales!: AdvancedSalesModel;

  constructor(
    private formBuilder: FormBuilder,
    private advanceSalesServices: AdvanceSalesServices,
    private advancedSalesSellerService: advancedSalesSellerService,
    private translate: TranslateService, private languageService: LanguageService,
    private auth: AuthService
  ) {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        translate.use('ar');
        document.body.classList.add('dir-rtl');
      } else if (localStorage.getItem("language") === "en") {
        translate.use('en');
        document.body.classList.remove('dir-rtl');
      }
    } else {
      translate.use('en');
      document.body.classList.remove('dir-rtl');
    }
  }

  async ngOnInit() {
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.business = await this.auth.getBusiness();
    this.id = this.business.id
    this.sliderForm = this.formBuilder.group({
      bussinesId: [''],
      advancesaleslimit: [this.selectedRam],
    });
    this.getLimit();
    this.advancedSalesSellerService.setParams({bussinesId:this.business.id});
    let result= await this.advancedSalesSellerService.make();
    if(result){
      this.sellerRunningAdvancedSales = result;
      let startDate = new Date();
      if (result.startDate) {
        startDate = new Date(this.sellerRunningAdvancedSales.startDate!);
      }
      this.sellerRunningAdvancedSales.startDate = moment(startDate).format("DD/MM/YYYY");
    }
  }

  getLimit() {
    if (this.business.advancedSalesLimit) {
      if (this.business.advancedSalesLimit > 1000) {
        this.ramMaxValue = this.business.advancedSalesLimit / 1000;
      } else {
        this.ramMaxValue = this.business.advancedSalesLimit / 100;
      }
    }
  }

  setRam(event: any) {
    let value = event.target.value;
    let business = this.business;
    this.selectedRam = value;
    this.selectedFees = value * 1000 * (+business.AdvancedFees / 100);
  }

  async onSubmit() {
    if (this.selectedRam == 0) {
      Swal.fire({
        text: this.translate.instant('Sellers.AdvanceSales.SpecifyAmountWarning'),
        icon: 'warning'
      });
      return
    }
    this.advanceSalesServices.setParams({
      advancesaleslimit: this.selectedRam + '000',
      bussinesId: this.id,
    });
    const response = await this.advanceSalesServices.make();
    try {
      if (response.status == true) {
        Swal.fire({
          text: response.message,
          icon: 'success'
        });
      }
      else if (response.status == false) {
        Swal.fire({
          text: this.translate.instant('Sellers.AdvanceSales.AdvanceSubmitWarning'),
          icon: 'warning'
        });
      }
    }
    catch {
      Swal.fire({
        text: "error happend please try again",
        icon: 'error'
      });
    }
  }
}
